import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import Card from "../../../atoms/Card"
import styled from "styled-components"
import TextButton from "../../../atoms/buttons/TextButton"
import { ArrowRight } from "../../../atoms/icons/ArrowRight"
import H1 from "../../../atoms/typography/H1"
import H2 from "../../../atoms/typography/H2"
import { HorizontalSpacer, Spacer } from "../../../atoms/spacers"
import { PackageIcon } from "../../../atoms/icons/PackageIcon"
import H3 from "../../../atoms/typography/H3"
import Body from "../../../atoms/typography/Body"
import { ContactPhoneIcon } from "../../../atoms/icons/ContactPhoneIcon"
import { LuggageIcon } from "../../../atoms/icons/LuggageIcon"
import { BackupIcon } from "../../../atoms/icons/BackupIcon"
import { Link } from "react-router-dom"

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const BottomBar = styled.div`
  padding: 2rem;
  width: 100%;
  background: ${(props) => props.theme.gradients.yellow};
`

const TextSection = styled.div`
  padding: 32px 40px;
`

const IconAndTitleContainer = styled.div`
  display: flex;
  align-items: center;
`

const InstantProductCard: React.FC = () => {
  return (
    <div>
      <Container>
        <Card noPadding>
          <div>
            <Row>
              <Col lg={6}>
                <Image src="https://images.ctfassets.net/kzqg847wz5jr/1HTD3ToijuTiFdVuUNyBGi/1fa54cebcb5f9cb0e8a4e62c3f27a6ae/Frame_567.png" />
              </Col>
              <Col lg={6}>
                <TextSection>
                  <H1>Satcube Instant</H1>
                  <H2>A complete and flexible rental solution</H2>
                  <HorizontalSpacer spacing={1.5} />
                  <IconAndTitleContainer>
                    <PackageIcon />
                    <Spacer spacing={0.5} />
                    <H3>Direct delivery</H3>
                  </IconAndTitleContainer>
                  <HorizontalSpacer spacing={0.25} />
                  <Body>The terminal is shipped to the destination of your choice within 2 business days.</Body>
                  <HorizontalSpacer spacing={1.5} />
                  <IconAndTitleContainer>
                    <ContactPhoneIcon />
                    <Spacer spacing={0.5} />
                    <H3>Training and support included</H3>
                  </IconAndTitleContainer>
                  <HorizontalSpacer spacing={0.25} />
                  <Body>Satcube provides training and support is available 24/7.</Body>
                  <HorizontalSpacer spacing={1.5} />
                  <IconAndTitleContainer>
                    <LuggageIcon />
                    <Spacer spacing={0.5} />
                    <H3>Highly portable products</H3>
                  </IconAndTitleContainer>
                  <HorizontalSpacer spacing={0.25} />
                  <Body>
                    The terminal and all necessary accessories are delivered in a hardcase, ready to move out the minute
                    it arrives.
                  </Body>
                  <HorizontalSpacer spacing={1.5} />
                  <IconAndTitleContainer>
                    <BackupIcon />
                    <Spacer spacing={0.5} />
                    <H3>Flexible data solutions</H3>
                  </IconAndTitleContainer>
                  <HorizontalSpacer spacing={0.25} />
                  <Body>Data capacity is included and can easily be managed online.</Body>
                  <HorizontalSpacer spacing={1.5} />
                </TextSection>
              </Col>
            </Row>
          </div>
          <Link to="/products/rental">
            <BottomBar>
              <Row justify="center">
                <TextButton color="white" title="Learn more and order" icon={<ArrowRight color="white" />} />
              </Row>
            </BottomBar>
          </Link>
        </Card>
      </Container>
    </div>
  )
}

export default InstantProductCard
